import React from 'react';
import { CircularProgress, Box } from '@mui/material';

interface Props {
  show: boolean;
  showFullScreen?: boolean;
}

const Loader = ({ show, showFullScreen }: Props) => {
  return show ? (
    <Box
      display='flex'
      justifyContent='center'
      py={2}
      alignItems='center'
      height={showFullScreen ? '100%' : 'unset'}
    >
      <CircularProgress />
    </Box>
  ) : null;
};

Loader.defaultProps = {
  showFullScreen: false
};

export default Loader;
